// extracted by mini-css-extract-plugin
export default {"table_title":"styles_table_title__3Qb6R","union_icon":"styles_union_icon__X8D6K","badge_circle":"styles_badge_circle__L6PE8","badge_success":"styles_badge_success__H+NM1"};